import { render, staticRenderFns } from "./InfoBill.vue?vue&type=template&id=70d5ea29&scoped=true"
import script from "./InfoBill.vue?vue&type=script&lang=js"
export * from "./InfoBill.vue?vue&type=script&lang=js"
import style0 from "./InfoBill.vue?vue&type=style&index=0&id=70d5ea29&prod&lang=scss&scoped=true"
import style1 from "./InfoBill.vue?vue&type=style&index=1&id=70d5ea29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d5ea29",
  null
  
)

export default component.exports